var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-min-h-screen tw-bg-[#e2e8f0] dark:tw-bg-[#0a0f18] tw-font-jakarta-sans tw-text-gray-800 dark:tw-text-slate-200 tw-transition-colors tw-duration-300",attrs:{"id":"app"}},[_c('router-view'),_c('portal-target',{attrs:{"name":"marketplace-popovers","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }